
/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 */

import {arConfig} from './ar';

export const frConfig = {
    ...arConfig.base,
    salaam:'Salaam',

home : {
    ...arConfig.home,
    login:'Connexion',
    about:'Service Moshaf pour lire, apprendre et mémoriser le Coran à tout moment et en tout lieu',
    article : 'Articles',
    contact : 'Contact',
},

profile : {
    profile : 'Profile',
    audio : 'Audio',
    monitor:'Monitor',
    akademy : 'Akademy',
    akademyApp : 'AkademyApp',
    setting : 'Settings',
}
}